import React from "react";
import { Layout } from "../../components/layout/Layout";
import { ModuleRouter } from "../../components/molecules";
import { CompanyProfileRoute } from "./companyProfile.routes";

type Props = {};

export function CompanyProfileModule({}: Props): React.ReactElement {
  return (
    <Layout>
      {CompanyProfileRoute.subRoutes && (
        <ModuleRouter subRoutes={CompanyProfileRoute.subRoutes} path={CompanyProfileRoute.path} />
      )}
    </Layout>
  );
}
